<script setup lang="ts">
import emblaCarouselVue from 'embla-carousel-vue';

withDefaults(
    defineProps<{
        hasThumbnails?: boolean;
        hasArrows?: boolean;
        hasDots?: boolean;
        height?: string;
        width?: number;
    }>(),
    { hasArrows: false, hasDots: true, hasThumbnails: false, width: 80 },
);

const [emblaRef, emblaApi] = emblaCarouselVue();

const amountOfSlides = ref(0);
const currentSlideIndex = ref(0);
const canScrollPrevious = ref(false);
const canScrollNext = ref(true);

onMounted(() => {
    emblaApi.value?.on('select', () => {
        currentSlideIndex.value = emblaApi.value?.selectedScrollSnap();
        canScrollPrevious.value = emblaApi.value?.canScrollPrev();
        canScrollNext.value = emblaApi.value?.canScrollNext();
    });
    amountOfSlides.value = emblaApi.value?.slideNodes()?.length;
});
</script>

<template>
    <section class="w-full">
        <!-- eslint-disable tailwindcss/no-custom-classname -->
        <div ref="emblaRef" class="embla__viewport h-full overflow-x-hidden">
            <div
                :class="`embla__container grid grid-flow-col touch-pan-y ${
                    width < 100
                        ? 'gap-dynamic [&>*:first-child]:ml-dynamic [&>*:last-child]:mr-dynamic'
                        : ''
                }`"
                :style="`grid-auto-columns: ${width}%;`"
            >
                <slot />
            </div>
            <div
                v-if="amountOfSlides > 1"
                class="mt-5 hidden gap-2 md:flex"
                :class="`${width < 100 ? 'mx-dynamic' : ''}`"
            >
                <button
                    :class="`transition-opacity ${
                        !canScrollPrevious && 'opacity-20'
                    }`"
                    :disabled="!canScrollPrevious"
                    class="rounded border border-gray-900 p-2"
                    @click="emblaApi?.scrollPrev"
                >
                    <JamBaseIcon icon-name="arrow-left" />
                </button>
                <button
                    :class="`transition-opacity ${
                        !canScrollNext && 'opacity-20'
                    }`"
                    class="rounded border border-gray-900 p-2"
                    :disabled="!canScrollNext"
                    @click="emblaApi?.scrollNext"
                >
                    <JamBaseIcon icon-name="arrow-right" />
                </button>
            </div>
            <div
                v-if="hasDots && amountOfSlides"
                class="mx-dynamic mt-4 flex gap-3 md:hidden"
            >
                <span
                    v-for="(slide, index) in amountOfSlides"
                    :key="`dot-${slide}`"
                    class="h-2 !rounded-full bg-gray-900 transition-all"
                    :class="[currentSlideIndex === index ? 'w-10' : 'w-2']"
                    @click="emblaApi?.scrollTo(index)"
                />
            </div>
        </div>
        <!-- eslint-enable tailwindcss/no-custom-classname -->
    </section>
</template>
